import type { IntlDateTimeFormat } from "vue-i18n";
import { UserLocaleCode } from "@/shared/@types/UserLocaleCode";

export const datetimeFormats = {
  [UserLocaleCode.DE]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.DE_AT]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.DE_CH]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.EN]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.FR]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.FR_BE]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.FR_CH]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.IT_CH]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.NL]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
  [UserLocaleCode.NL_BE]: {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: { year: "numeric", month: "long", day: "2-digit", weekday: "long" },
    time: { hour: "2-digit", minute: "2-digit", hour12: false },
  },
} as const satisfies Record<string, IntlDateTimeFormat>;
